import { createAction, props } from '@ngrx/store';
import { DomainSettingsList } from '../../models';

export const getDomainSettingsAction = {
  get: createAction('[Domain Settings] Get Settings'),
  success: createAction(
    '[Domain Settings] Get Settings Success',
    props<{ settings: DomainSettingsList }>(),
  ),
  fail: createAction('[Domain Settings] Get Settings Fail'),
};

export const getAccountSettingActions = {
  get: createAction(
    '[Domain Settings] Get Setting',
    props<{ accountId: string }>(),
  ),
  success: createAction('[Domain Settings] Get Setting Success'),
  fail: createAction('[Domain Settings] Get Setting Fail'),
};

export const searchSettingsAction = {
  search: createAction(
    '[Domain Settings] Search Settings',
    props<{ searchQuery: string }>(),
  ),
};

export const deleteSettingsActions = {
  delete: createAction(
    '[Domain Settings] Delete Domain',
    props<{ accountId: string }>(),
  ),
  success: createAction(
    '[Domain Settings] Delete Domain Success',
    props<{ accountId: string }>(),
  ),
  fail: createAction('[Domain Settings] Deete Domain Fail'),
};

export const toggleAccountSettingActions = {
  toggle: createAction(
    '[Domain Settings] Toggle Domain',
    props<{ accountId: string; enabled: boolean }>(),
  ),
  success: createAction(
    '[Domain Settings] Toggle Domain Success',
    props<{ accountId: string; enabled: boolean }>(),
  ),
  fail: createAction('[Domain Settings] Toggle Domain Fail'),
};
